import { get, includes, isEmpty } from 'lodash';
import settings from '../../utils/settings';
import queryString from 'query-string';
import { constructQueryString } from '../../utils/helper';
import store from '../../store';

const getUrl = helperParams => {
  return {
    leadApp: {
      backSelfLead: window.location.href.split('/create-lead')[0],
      createSelfLead: `${window.location.href.split(
        '/create-lead'
      )[0]}/${helperParams.leadId}?journey_type=${helperParams.journeyType}`,
      entryPointSelfLead: settings.enlightenMenuUrl(`${window.location.pathname.substring(1)}/create-lead`),
      viewDetailsLead: `/manager/dashboard/${helperParams.companyId}/leads/${helperParams.lead_id}?journey_type=${helperParams.journey_type}`,
      viewBOMinLead: `/manager/dashboard/${helperParams.companyId}/leads/${helperParams.lead_id}?journey_type=${helperParams.journey_type}&leadView=${helperParams.lead_view}`
    },
    dashboard: {
      viewEinDashboard: `/manager/dashboard/ein-dashboard`,
      accountInformation: {
        company: 'company',
        branches: 'branches',
        users: 'users',
        areaCoverage: 'area-coverage',
        leadProgram: 'lead-program',
        einProgram: 'ein-program'
      },
      services: {
        permit: 'permitting-assistance',
        sgip: 'sgip-incentive',
        designTool: 'design-tool',
        lpp: 'labor-protection',
        bom: 'bom',
        dataPlanExtension: 'data-plan-extension'
      },
      dataPrivacy: {
        apiAccess: 'api-access',
        thirdPartyReporting: 'third-party-reporting',
        profiles: 'profiles'
      },
      quickLinks: {
        commercial: '/manager/dashboard/commercial'
      },
      systemsTable: {
        leadURL: `dashboard/${helperParams.companyId}/leads/${helperParams.id}?journey_type=${helperParams.journey_type}`,
        viewFullList: `dashboard/${helperParams.companyId}/leads`,
        leadCommercialURL: `/manager/dashboard/${helperParams.companyId}/leads?from=commercial`,
        leadExistingBomUrl: `/manager/dashboard/${helperParams.companyId}/leads?from=bom-dialog`
      }
    },
    einDashboard: {
      bannerUrl: helperParams.url
    },
    systemEstimatorPopup: {
      company: `${window.location.origin}/manager/dashboard/company`
    },
    einProgram: {
      dashboard: '/manager/dashboard'
    },
    leadProgram: {
      addUser: '/manager/account/users/create'
    },
    users: {
      addUserSuccess: '/manager/account/users'
    },
    branches: {
      createBranchSuccess: '/manager/account/branches'
    },
    sgip: {
      company: '/manager/dashboard/company#installation-details'
    },
    drs: {
      dashboard: settings.drsUiUrl(`manager/dashboard/design-review`)
    }
  };
};

export const getPlatformBasedUrl = (keyName, helperParams = {}) => {
  const { search } = window.location;
  const { platform = '' } = queryString.parse(search);
  const fromITK =
    store.getState().appReducer.fromITK || platform === 'itk' || includes(window.location.href, 'platform=itk');
  let result = get(getUrl(helperParams), `${keyName}`);
  if (fromITK) {
    const pathname = result.split('?')[0];
    const queryParamsString = queryString.parse(result.split('?')[1]);
    result = pathname + constructQueryString({ ...queryParamsString, ...(fromITK && { platform: 'itk' }) });
  }
  return result;
};
